export const crudMode = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
  COPY: 'copy',
}

export const fileType = {
  FILE: 0,
  PERSONPROFILEPICTURE: 1,
  PROJECTLOGO: 2,
  PROJECTIMAGE: 3,
  PARTNERLOGO: 4,
  EVENTLOGO: 5,
  EVENTIMAGE: 6,
}

export default class Enum {
  static get Mode() {
    return crudMode
  }
  static get FileType() {
    return fileType
  }
}



// WEBPACK FOOTER //
// ./src/shared/enum.js